var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersonalLoan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 122.88 100.58",
    style: {
      enableBackground: "new 0 0 122.88 100.58"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, ".st0{fill-rule:evenodd;clip-rule:evenodd;}")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#0B2B4C",
    className: "st0",
    d: "M29.83,87.77V50.85h16.61c7.04,1.26,14.08,5.08,21.12,9.51h12.9c5.84,0.35,8.9,6.27,3.22,10.16 c-4.52,3.32-10.49,3.13-16.61,2.58c-4.22-0.21-4.4,5.46,0,5.48c1.53,0.12,3.19-0.24,4.64-0.24c7.63-0.01,13.92-1.47,17.77-7.5 l1.93-4.51l19.19-9.51c9.6-3.16,16.43,6.88,9.35,13.87c-13.9,10.11-28.15,18.43-42.73,25.15c-10.59,6.44-21.18,6.22-31.76,0 L29.83,87.77L29.83,87.77z M42.41,0l71.41,19.13l-9.95,37.13L32.46,37.13L42.41,0L42.41,0z M76.08,17.22 c6.04,1.62,9.62,7.81,8,13.85c-1.62,6.04-7.81,9.62-13.85,8c-6.04-1.62-9.62-7.81-8-13.85C63.84,19.18,70.03,15.6,76.08,17.22 L76.08,17.22z M52.83,8.85l47.48,12.72c-0.81,3.02,0.99,6.15,4.02,6.95l-3.93,14.68c-3.02-0.81-6.15,0.99-6.95,4.02L45.96,34.5 c0.81-3.02-0.99-6.14-4.02-6.95l3.93-14.68C48.89,13.68,52.02,11.88,52.83,8.85L52.83,8.85z M0,47.3h24.83v44.18H0V47.3L0,47.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonalLoan);
export default __webpack_public_path__ + "static/media/personal-loan.93fb4dd3919e050b76492d08f85fafde.svg";
export { ForwardRef as ReactComponent };